export const selectStyles = theme => ({
  control: (provided, state) => ({
    ...provided,
    boxShadow: state.isFocused && `0 0 0 2px ${theme.colors.primary['300']}`,
    borderColor: state.isFocused ? theme.colors.primary['400'] : theme.colors.neutral['300'],
    minWidth: 256,
    margin: 8,
  }),

  menu: () => ({}), // Remove all custom styles from the menu (we are styling it here)
});
